import { render, staticRenderFns } from "./PageTemplateRenderer.vue?vue&type=template&id=72777b44&scoped=true"
import script from "./PageTemplateRenderer.vue?vue&type=script&lang=js"
export * from "./PageTemplateRenderer.vue?vue&type=script&lang=js"
import style0 from "./PageTemplateRenderer.vue?vue&type=style&index=0&id=72777b44&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72777b44",
  null
  
)

export default component.exports